<template>
  <div class="home" >
    <Heads/>
    <div class="main">
      <div class="dialog" v-if="!success">
        <form  style="width: 100%;height: 100%;" method="post" action="" enctype="multipart/form-data" id="myform">
        <div class="title">
          <span style="display:inline-block;float:left;">上传影像文件</span> 
          <span style="color:#8E8E93;font-size:14px;margin-left:20px;float:left;display:inline-block;">上传文件（支持*.dcm，*.zip，*.rar）的文件。一次只能上传一个文件</span>
        </div>
        <div class="upload-cont">
          <input type="text" v-model="obj.secretId" name="secretId" style="display:none;" />
          <input type="text" v-model="obj.noticeUri" name="noticeUri" style="display:none;" />
          <a href="javascript:;" class="file upload-icon" >
            <img src="../assets/upload-icon.png" alt="点击上传" >
            <span >选择文件</span>
            <input id='files' type="file" name="files" />
            <div class="showFileName"></div>
          </a>
        </div>
        <div class="upload-submit">
          <input class="upload-submit" type="submit" value="确定上传" style="font-size:16px;"/>
        </div>
        </form>
      </div>
      <div class="loading-shade" v-if="progressLoad">
        <div class="upload-error" >
          <div style="width:100%;height:100%;position:relative;text-align: center;">
            <el-progress class="progressval" :text-inside="true" :stroke-width="24" :percentage="progressval" status="success"></el-progress>
            <span id="time" >上传中，上传速度：0，剩余时间：0</span> 
          </div>
        </div>
      </div>
      <div class="upload-success" v-if="success">
        <div style="width:100%;height:250px;">
          <div style=""><img src="../assets/upload-success.png" alt="上传成功" style="width:60px;height:60px;"></div>
          <div style="margin-top:10px;font-size:16px;color:#000;height:20px;">上传成功</div>
          <div style="margin-top:10px;font-size:16px;color:#000;height:20px;">请在3分钟后在微信公众“我的-影像报告”列表中查看</div>
          <div style="margin-top:10px;font-size:12px;color:#8E8E93;height:20px;">通过查看第三步点击“前往查看”可进入影像报告列表中查看影像</div>
          <div class="upload-return">
            <button style="" @click="returnUpload()">返回</button>
          </div>
        </div>
      </div>
    </div>
    <div class='mask' v-if='error'></div>
    <div class="upload-error" v-if="error">
      <div style="width:100%;height:100%;position:relative;text-align: center;">
        <img src="../assets/close.png" alt="" style="width:16px;height:16px;position:absolute;right:10px;top:10px;cursor: pointer;" @click='error = false'>
        <div style="padding-top:55px;"><img src="../assets/upload-error.png" alt="上传失败" style="width:60px;height:60px;"></div>
        <div style="margin-top:10px;font-size:16px;color:#000;height:20px;">{{errortest}}</div>
      </div>
    </div>
    <iframe id="rfFrame" name="rfFrame" frameborder="0" src="" style="display:none;"></iframe>  
    <Footers />
  </div>
</template>
<script>

import Heads from '@/components/header.vue'
import Footers from "@/components/footervue.vue";
import $ from 'jquery'
// import QRCode from 'qrcodejs2'
import { GetSecretId,SaveVUInfoRequest } from '@/api/upload'
export default {
  name: 'upload',
  data() {
    return {
      fileList:[],
      success:false,
      error:false,
      progressLoad:false,
      fullscreenLoading:false,
      obj:{
        secretId :"",
        noticeUri :"https://film.rimag.com.cn/api/videoupload/VideoUploadNotice",
        files :[]
      },
      StoreId:'',
      FileName:'',
      errortest: '',
      progressval: 0,
    }
  },
  components: {
    Heads,Footers
  },
   methods: {  
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      handleChange(files, fileList){
        this.obj.files = [];
        this.obj.files.push(files)
      },
      beforeAvatarUpload(file) {
        var testmsg=file.name.substring(file.name.lastIndexOf('.')+1)				
				const extension = testmsg === 'dcm'
				const extension1 = testmsg === 'zip'
				const extension2 = testmsg === 'rar'
        if(!extension && !extension2 && !extension1) {
					this.$message({
						message: '上传文件只能是 dcm、zip、rar格式!',
						type: 'warning'
					});
        }
        return extension1 || extension2 || extension
      },
      handleSuccess(response, file, fileList){ // 上传成功回调
        if(response.code == 20000){
          this.StoreId = response.result
          this.FileName = file.name
          this.saveVUInfoRequest()
        }else{
          this.error = true;
        }
      },
      handleError(){ // 上传失败回调
        this.error = true;
      },
      returnUpload(){
        this.$router.push({path:'/'})
      },
      getSecretId(){ // 获取管道id
        GetSecretId({qrCodeGuid:this.$route.query.guid,wxUserId:this.$route.query.userId}).then((response) => {
          if(response.code == 20000){
            this.obj.secretId = response.data
          }
        }).catch(error => {
        })
      },
      saveVUInfoRequest() { // 保存上传信息
        SaveVUInfoRequest({QrCodeGuid:this.$route.query.guid,wxUserId:this.$route.query.userId,StoreId:this.StoreId,FileName:this.FileName,SecretId:this.obj.secretId}).then((response) => {
          if(response.code == 20000){
          this.progressLoad = false;
          this.progressval = 0;
          this.success = true;
          }
        }).catch(error => {
          this.progressLoad = false;
          this.error = true;
        })
      }
  },  
  mounted () {  //调用
    var vm = this
    this.getSecretId();
    $(".file").on("change","input[type='file']",function(){
      var filePath=$(this).val();
      if(filePath.indexOf("dcm")!=-1 || filePath.indexOf("zip")!=-1 || filePath.indexOf("rar")!=-1){
          var arr=filePath.split('\\');
          var fileName=arr[arr.length-1];
          vm.FileName=arr[arr.length-1];
          $(".showFileName").html(fileName);
          
      }else{
        vm.$message.error("文件类型不合法,只能是(*.zip,*.dcm或*.rar)类型！")
        $(".showFileName").html("");
        return false 
      }
    })
    var fm = document.getElementById("myform");
    fm.onsubmit=function(evt){
        vm.progressLoad = true;
        var ot;
        var oloaded;
        var fd = new FormData(fm);
        var xhr = new XMLHttpRequest();
        var file = document.getElementById('files').value;
        //fd.append('files', fileInputElement.files[0]);
        if(file == ""){
          vm.progressLoad = false;
          vm.$message.error('还没有选上传的文件');
          return false;
        }else{
          if(iszip(file) == false){
            vm.progressLoad = false;
            vm.$message.error("文件类型不合法,只能是(*.zip,*.dcm或*.rar)类型！")
            return false;
          }
        }
        xhr.upload.onloadstart = function() { //上传开始执行方法
            ot = new Date().getTime(); //设置上传开始时间
            oloaded = 0; //设置上传开始时，以上传的文件大小为0
        };
        xhr.onreadystatechange=function(){
          if(xhr.readyState==4){
            var returnData = JSON.parse(xhr.responseText);
            if (returnData.code == '20000') {
            var strResult = returnData.result;  // 返回查询状态的字符串 arrBpxZFR0SRJ_U4SVqtEQ
                //循环查询结果是否返回
                vm.StoreId = strResult
                vm.saveVUInfoRequest()
            }else{
                //上传失败
                vm.progressval = 0;
                vm.progressLoad = false;
                vm.errortest = returnData.message;
                vm.error = true
            }
          }
          
        };
        // xhr.onreadystatechange = function() {   // 等待ajax请求完成。
        //     if (xhr.status === 200) {
        //         console.log(xhr.responseText);
        //     } else {
        //         console.log('上传出错');
        //     }
        // };
        // 获取上传进度
        xhr.upload.onprogress = function(event) { 
            if (event.lengthComputable) {
                var percent = Math.floor(event.loaded / event.total * 100);
                vm.progressval = percent
                // document.querySelector("#progress .progress-item").style.width = percent + "%";
                // 设置进度显示
            }
            var time = document.getElementById("time");
            var nt = new Date().getTime(); //获取当前时间
            var pertime = (nt - ot) / 1000; //计算出上次调用该方法时到现在的时间差，单位为s
            ot = new Date().getTime(); //重新赋值时间，用于下次计算
            var perload = event.loaded - oloaded; //计算该分段上传的文件大小，单位b      
            oloaded = event.loaded; //重新赋值已上传文件大小，用以下次计算

            //上传速度计算
            var speed = perload / pertime; //单位b/s
            var bspeed = speed;
            var units = 'b/s'; //单位名称
            if (speed / 1024 > 1) {
                speed = speed / 1024;
                units = 'k/s';
            }
            if (speed / 1024 > 1) {
                speed = speed / 1024;
                units = 'M/s';
            }
            speed = speed.toFixed(1);
            //剩余时间
            var resttime = ((event.total - event.loaded) / bspeed).toFixed(1);
            time.innerHTML = '上传中，上传速度：' + speed + units + '，剩余时间：' + resttime + 's';
        };
        xhr.open("post",'https://pacs-center.rimagdata.com:8001/api/Files/UploadDcmFiles');
        xhr.send(fd);
        evt.preventDefault();
    };
    function iszip(fileName){
      if(fileName!=null && fileName !=""){
        //lastIndexOf如果没有搜索到则返回为-1
        if (fileName.lastIndexOf(".")!=-1) {
          var fileType = (fileName.substring(fileName.lastIndexOf(".")+1,fileName.length)).toLowerCase();
          var defaultype = "zip";
          var defaultype1 = "rar";
           var defaultype2 = "dcm";
          if (fileType == defaultype || fileType == defaultype1 || fileType == defaultype2) {
              return true;
          } else{
              //alert("文件类型不合法,只能是(*.zip或*.rar)类型！");
              return false;
          }
        } else{
            //alert("文件类型不合法,只能是(*.zip或*.rar)类型！");
            return false;
        }
      }
    }
  }  
}
</script>
<style rel='stylesheet/scss' lang='scss' scoped>
.home{
  width: 100%;
  height: 100%;
  background-color: #EFEFF4;
  .file {
    position: relative;
    display: inline-block;
    border-radius: 4px;
    padding: 4px 12px;
    overflow: hidden;
    color: #1E88C7;
    text-decoration: none;
    text-indent: 0;
    line-height: 20px;
}
.file input {
    position: absolute;
    font-size: 100px;
    right: 0;
    top: 0;
    opacity: 0;
}
.file:hover {
    cursor: pointer;
    text-decoration: none;
}
.showFileName{
  margin-top: 10px;
  color:#8E8E93;
  font-size: 16px;
}
  .upload-success{
    height: 70%;
    width: 60%;
    border-radius: 6px;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 10px 100px 0px rgba(6, 37, 94, 0.5);
    text-align: center;
    justify-content: center;
    align-items: center;
    display: -webkit-flex;
  }
  .mask{
      position: absolute;
      left:0;
      top:0;
      width: 100%;
      height: 100%;
      border-radius: 6px;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 1001;
  }
  .loading-shade {
  position: fixed;
  background: rgba(0, 0, 0, .3);
  z-index: 102000000000000;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  }
  .upload-error{
    position: absolute;
    width: 400px;
    height:200px;
    top:50%;
    left:50%;
    margin-left: -200px;
    margin-top: -100px;
    background: #fff;
    z-index: 2001;
    border-radius:6px;
  }
  .upload-error .progressval{
    width: 250px;
    margin: 40px auto;
  }
  .upload-error #time{
    display: block;
    margin: 20px auto;
  }

  .upload-return{
    width: 100%;
    height: 100px;
    line-height: 100px;
    button{
      width: 300px;
      height: 45px;
      border-radius: 6px;
      background-color: rgba(6, 37, 94, 1);
      border:none;
      color:#fff;
      cursor: pointer;
    }
  }
  .main{
    background: url(../assets/bg.png) no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: calc(100% - 100px);
    background-color: #fff;
    text-align: center;
    justify-content: center;
    align-items: center;
    display: -webkit-flex;
    .dialog{
      height: 70%;
      width: 60%;
      display:inline-block;
      border-radius: 6px;
      background-color: rgba(255, 255, 255, 1);
      box-shadow: 0px 10px 100px 0px rgba(6, 37, 94, 0.5);
      .title{
        height: 80px;
        color: rgba(0, 0, 0, 1);
        font-size: 24px;
        text-align: left;
        padding-left:30px;
        line-height: 80px;
        border-bottom: 1px solid #E5E5EA;
        font-family: PingFangSC-Semibold;
      }
      .upload-cont{
        width: 100%;
        height: calc(100% - 174px);
        background-color: #fff;
        text-align: center;
        justify-content: center;
        align-items: center;
        display: -webkit-flex;
        .upload-icon{
          display: inline-block;
          width: 125px;
          height: 160px;
          img{
            width: 90%;
          }
          span{
            margin-top: 20px;
            color: rgba(6, 37, 94, 1);
            font-size: 16px;
            font-family: PingFangSC-Medium;
          }
        }
      }
      .upload-submit{
        width: 100%;
        height:93;
        border-top: 1px solid #E5E5EA;
        line-height: 93px;
        button,input{
          width: 300px;
          height: 45px;
          line-height: 45px;
          border-radius: 6px;
          background-color: rgba(6, 37, 94, 1);
          border:none;
          color:#fff;
          cursor: pointer;
        }
      }
    }
  }
}
</style>